import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAp2YVJaAWNVKUTS4BJKc7y1duUAHcC2lo",
  authDomain: "sme-qr-pay.firebaseapp.com",
  projectId: "sme-qr-pay",
  storageBucket: "sme-qr-pay.firebasestorage.app",
  messagingSenderId: "356837487765",
  appId: "1:356837487765:web:c5df9b16ff4b8b915f579c",
  measurementId: "G-9F0VXRNB7W"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
